<div *ngIf="collapsed" cdkDrag autoScroll class="sam-full-width dragged-item" fxLayout="row">
   <div class="sam-margin-right-large sam-center" cdkDragHandle>
      <fa-icon class="sam-margin-left sam-center" [icon]="dragIcon"></fa-icon>
   </div>
   <div *cdkDragPreview></div>
   <fa-icon
      class="sam-margin-right-medium sam-center sam-icon-width"
      [icon]="iconName$ | async | iconNameToIconDefinition$ | async"
   ></fa-icon>
   <div class="sam-button-text">
      {{ actionTitleTranslation$ | async | translate }}
   </div>
   <div class="remove-tab sam-margin-right" (click)="removeAction()">
      <fa-icon [icon]="removeTabIcon"></fa-icon>
   </div>
   <div class="sam-display-none">
      <ng-template componentHost></ng-template>
   </div>
</div>

<div *ngIf="!collapsed" fxLayout="column">
   <div fxLayout="row">
      <label class="sam-margin-left-medium sam-center-left" fxFlex="40%">{{
         'brick.brick_definitions.toolbar_brick.settings.action_typ' | translate
      }}</label>

      <kendo-dropdownlist
         fxFlex="60%"
         class="sam-margin-left"
         [value]="actionTyp$ | async"
         [data]="userActionPossibleValues$ | i18nSort: 'getTranslationKey$':store | async"
         [textField]="'value'"
         [valueField]="'value'"
         [valuePrimitive]="false"
         (selectionChange)="changeActionTyp($event)"
      >
         <ng-template kendoDropDownListValueTemplate let-dataItem>
            <fa-icon class="sam-margin-right" *ngIf="dataItem" [icon]="dataItem.defaultIcon"></fa-icon>
            {{ dataItem?.getTranslationKey$(store) | async | translate }}
         </ng-template>
         <ng-template kendoDropDownListItemTemplate let-dataItem>
            <fa-icon
               fxLayout="column"
               class="sam-margin-right"
               *ngIf="dataItem"
               [icon]="dataItem.defaultIcon"
               [fixedWidth]="true"
            ></fa-icon>
            <div fxLayout="column">
               <div fxLayout="row">
                  {{ dataItem?.getTranslationKey$(store) | async | translate }}
               </div>
               <div fxLayout="row" [style.font-size]="'0.9em'" [style.opacity]="'0.8'">
                  {{ dataItem?.descriptionTextKey | translate }}
               </div>
            </div>
         </ng-template>
      </kendo-dropdownlist>
   </div>

   <div fxLayout="row">
      <label class="sam-margin-left-medium sam-center-left" fxFlex="40%">{{
         'brick.brick_definitions.toolbar_brick.settings.action_title' | translate
      }}</label>
      <input
         (input)="actionTitleChanged($event.target.value)"
         [value]="(actionContent$ | async).title"
         [style.width]="'100%'"
         kendoTextBox
      />
   </div>

   <div fxLayout="row" fxFlex="1 1 auto">
      <label class="sam-margin-left-medium sam-center-left" fxFlex="40%">{{
         'brick.brick_definitions.toolbar_brick.settings.icon' | translate
      }}</label>

      <div fxFlex="60%">
         <samweb-icon-picker
            fxFlex="1 1 auto"
            [value]="iconName$ | async | iconNameToIconDefinition$ | async"
            (valueChanged)="actionIconChanged($event)"
            class="sam-margin-right"
         >
         </samweb-icon-picker>

         <kendo-colorpicker
            [format]="'hex'"
            [gradientSettings]="{ opacity: false }"
            [view]="'gradient'"
            [value]="(actionContent$ | async).color"
            (valueChange)="actionColorChanged($event)"
         ></kendo-colorpicker>
         <samweb-clear-button [toolTipText]="'common.clear_color' | translate" (click)="clearActionColor()">
         </samweb-clear-button>
      </div>
   </div>
   <ng-template componentHost></ng-template>
</div>
